if (!window.customElements.get('read-more')) {
  class ReadMore extends HTMLElement {
    constructor() {
      super();
      this.fullContent = this.textContent.trim();
      let numberOfWords = Number(this.dataset.words) || 60;
      this.wordLimit = numberOfWords;
      // set max width on mobile to be half of the original number of words
      this.wordLimit = window.innerWidth < 768 ? Math.min(Math.floor(numberOfWords * 0.4), 18) : numberOfWords;

      this.truncatedContent = this.getTruncatedContent(this.fullContent, this.wordLimit);
      this.isExpanded = false;
      this.readMoreLabel = this.dataset.readMoreLabel || 'Read more >>';
      this.render();

      // when media query change is detected, re-render the component
      const mediaQuery = window.matchMedia('(max-width: 767px)');
      mediaQuery.addEventListener('change', (e) => {
        this.wordLimit = window.innerWidth < 768 ? Math.min(Math.floor(numberOfWords * 0.4), 18) : numberOfWords;
        this.truncatedContent = this.getTruncatedContent(this.fullContent, this.wordLimit);
        this.render();
      });
    }

    getTruncatedContent(text, wordLimit) {
      const words = text.split(' ');
      this.wordLength = words.length;
      if (words.length > wordLimit) {
        return words.slice(0, wordLimit).join(' ') + '...';
      }
      return text;
    }

    toggleContent() {
      this.isExpanded = !this.isExpanded;
      this.render();
    }

    render() {
      //console.log(this.wordLength, this.wordLimit);
      if (this.wordLength <= this.wordLimit) return this.innerHTML = this.fullContent;
      this.innerHTML = this.isExpanded ? `${this.fullContent} <span>Show less <<</span>` : `${this.truncatedContent} <span>${this.readMoreLabel}</span>`;
      this.querySelector('span').addEventListener('click', () => this.toggleContent());
    }
  }

  customElements.define('read-more', ReadMore);
}
